import pic from '../../images/profilePicture.png';
import './index.css';

export default function ProfilePicture() {
  return <img className='profile-picture' src={pic} alt='Profile'></img>;
}
